export enum PaymentType {
    CashCheck,
    Card,
    Venmo,
    Other
}